import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const FormPane = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 1.563rem;

  ${mediaQuery('md')} {
    flex-grow: ${(props) => (props.width ? 'unset' : 1)};
    width: ${(props) => props.width || 'unset'};

    > * {
      width: 100%;
      max-width: 100%;
    }
  }
`;
